<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [title]="'Exercise Performance Over Time'"
  [options]="options"
  [translateLabels]="true"
  [stacked]="true"
></app-bar-chart>
